export default "__VITE_ASSET__Dx_bzs5O__"